// transactionsFilterCells — supplement filter controls (cross-field /
// non-schema filters) for the transactions filter sets.
//
// Split out of `transactionsFilters.tsx` so that module exports only filter
// definitions and declares no components (react-refresh/only-export-components).

import React from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@ds/editable/Checkbox";
import { Select } from "@ds/forms/Select";
import type { FilterDef } from "@ds/tables/types";

type FilterControlProps = React.ComponentProps<NonNullable<FilterDef["component"]>>;

import { ALL_CHECK_KEYS } from "./transactionChecklist";

export const ChecklistMulti: React.FC<Partial<FilterControlProps>> = (p) => {
  const { t } = useTranslation();
  return (
    <Select multiple maxTagCount="responsive" allowClear placeholder="Brakujące kroki..."
      options={ALL_CHECK_KEYS.map((key) => ({ label: t(`transactions.checklist.${key}`, key), value: key }))}
      minWidth={280} {...p} />
  );
};

/** "Pokaż tylko anulowane" — single checkbox; checked → status_override eq cancelled. */
export const CancelledCheckbox: React.FC<Partial<FilterControlProps>> = (p) => (
  <Checkbox
    checked={!!p.value}
    onChange={(checked) => p.onChange?.(checked)}
    label="Tylko anulowane"
    testId="filter-only_cancelled"
  />
);

// ─── Supplement filters ──────────────────────────────────────────────────
//
// The schema-mapped filters (product / places / commercial companies / exporter
// / importer / employees / dates / border / gd / transit) auto-apply via
// `EntityListPage` (it reads each `transactionSchema.<field>.filterable`). These
// arrays carry ONLY the filters that don't map to a single schema field; the
// page MERGES them with the auto set. `statuses` is the lone quick supplement.

// Quick strip: the load/unload place companies (also listed in the advanced
// drawer). `name` matches the schema column so they bind to the same form field.
/** none | partial | full invoiced-status multi-select (load/unload sides). */
export const InvoicedStatusMulti: React.FC<Partial<FilterControlProps>> = (p) => (
  <Select multiple maxTagCount="responsive" allowClear placeholder="Status FV..."
    options={[
      { label: "Brak",      value: "none" },
      { label: "Częściowo", value: "partial" },
      { label: "Pełne",     value: "full" },
    ]} minWidth={160} {...p} />
);
